import React from "react";
import { css, StyleSheet } from "aphrodite";
import { Button } from "react-bootstrap";
import moment from "moment";
import { connect } from "react-redux";
import DatePickerField from "../../GenericComponents/DatePickerField";
import "./DateFilter.css";

class DateFilter extends React.Component {
  constructor() {
    super();
    this.wrapperRef = React.createRef();
    this.state = {
      interval: 30,
      showOptions: false,
      showDateFilter: false,
      customOptionLabel: "CUSTOM PERIOD",
      startDate: moment(),
      endDate: moment(),
      isCustom: false,
    };
  }

  componentDidMount = () => {
    const {
      interval = 30,
      filterStartDate,
      filterEndDate,
      isCustom,
    } = this.props;

    let customOptionLabel = "CUSTOM PERIOD";
    if (isCustom) {
      customOptionLabel =
        filterStartDate.format("MM/DD/YYYY") +
        " TO " +
        filterEndDate.format("MM/DD/YYYY");
    }

    this.setState({
      interval: interval,
      startDate: filterStartDate,
      endDate: filterEndDate,
      isCustom: isCustom,
      customOptionLabel,
    });

    document.addEventListener("mousedown", this.handleOutsideClick);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  };

  handleOutsideClick = (e) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ showOptions: false });
    }
  };

  getSelectedLabel = () => {
    const { interval, isCustom, customOptionLabel } = this.state;
    if (isCustom) return customOptionLabel;
    const option = this.props.selectOptions.find((o) => o.id === interval);
    return option ? option.name : "Select...";
  };

  toggleOptions = () => {
    this.setState((prev) => ({
      showOptions: !prev.showOptions,
      showDateFilter: false,
    }));
  };

  selectOption = (option) => {
    if (+option.id === 1) {
      this.setState({
        showOptions: false,
        showDateFilter: true,
        isCustom: true,
      });
      this.props.changeInterval(option.id, true);
    } else {
      this.setState({
        interval: option.id,
        showOptions: false,
        showDateFilter: false,
        isCustom: false,
        customOptionLabel: "CUSTOM PERIOD",
      });
      this.props.changeInterval(option.id, false);
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const nextInterval = Number(nextProps.interval);
    if (nextInterval !== this.state.interval) {
      this.setState({ interval: nextInterval });
    }
  };

  handleChangeStart = (fieldName, date) => {
    let startDate = moment(date).startOf("day");
    let endDate = this.state.endDate;
    let maxEndDate = startDate.clone().add(365, "days");
    if (endDate.isAfter(maxEndDate)) {
      endDate = maxEndDate;
    }

    if (endDate.isBefore(startDate)) {
      endDate = startDate.clone();
    }
    this.setState({ startDate, endDate });
  };

  handleChangeEnd = (fieldName, date) => {
    this.setState({ endDate: moment(date).endOf("day") });
  };

  setCustomInterval = () => {
    let customOptionLabel =
      this.state.startDate.format("MM/DD/YYYY") +
      " TO " +
      this.state.endDate.format("MM/DD/YYYY");
    this.setState({
      interval: 0,
      customOptionLabel,
      showDateFilter: false,
      isCustom: true,
    });
    this.props.setCustomSearchDate(this.state.startDate, this.state.endDate);
  };

  render() {
    const { interval, showOptions, showDateFilter } = this.state;

    let maxEndDate = this.state.startDate.clone().add(365, "days");
    if (maxEndDate.isAfter(moment())) {
      maxEndDate = moment();
    }

    return (
      <div className="date-filter-wrapper" ref={this.wrapperRef}>
        <button
          type="button"
          className="date-filter-trigger"
          onClick={this.toggleOptions}
          aria-expanded={showOptions}
          aria-haspopup="listbox"
        >
          <span className="date-filter-trigger-label">
            {this.getSelectedLabel()}
          </span>
          <span className="date-filter-trigger-arrow">▼</span>
        </button>

        {showOptions && (
          <div className="date-filter-menu" role="listbox">
            {this.props.selectOptions.map((option) => (
              <div
                key={option.id}
                role="option"
                aria-selected={option.id === interval}
                className={`date-filter-option${
                  (option.id === interval && !this.state.isCustom) ||
                  (option.id === 1 && this.state.isCustom)
                    ? " active"
                    : ""
                }`}
                onClick={() => this.selectOption(option)}
              >
                {option.name}
              </div>
            ))}
          </div>
        )}

        {showDateFilter ? (
          <div className="date-filter-custom-panel">
            <div style={{ display: "flex", padding: "10% 0 5% 0" }}>
              <div style={{ color: "#FFF", padding: "0 5%" }}>From:</div>
              <DatePickerField
                name={"fromDate"}
                value={this.state.startDate.toDate()}
                startDate={this.state.startDate.toDate()}
                endDate={this.state.endDate.toDate()}
                minDate={new Date().setFullYear(new Date().getFullYear() - 100)}
                maxDate={moment().toDate()}
                placeholder="Enter date of birth..."
                action={this.handleChangeStart}
                selectsStart
                disabledKeyboardNavigation
                className={"date-input form-control"}
              />
            </div>
            <div style={{ display: "flex", padding: "5% 0" }}>
              <div style={{ color: "#FFF", padding: "0 10%" }}>To:</div>
              <DatePickerField
                name={"endDate"}
                value={this.state.endDate.toDate()}
                startDate={this.state.startDate.toDate()}
                endDate={this.state.endDate.toDate()}
                minDate={this.state.startDate.toDate()}
                maxDate={maxEndDate.toDate()}
                placeholder="Enter date of birth..."
                action={this.handleChangeEnd}
                selectsStart
                disabledKeyboardNavigation
                className={"date-input form-control"}
              />
            </div>
            <div
              className="customDatePickerWidth"
              style={{
                display: "inline-flex",
                color: "#FFF",
                padding: "0",
                fontSize: "14px",
              }}
            >
              Custom period can not be greater
              <br /> than 365 days.
            </div>
            <br />
            <br />
            <div style={{ marginLeft: "40px" }}>
              <Button
                className={css(divStyles.buttonStyle)}
                type="button"
                onClick={this.setCustomInterval}
              >
                OK
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connect(
  (store) => {
    return {
      filterStartDate: store.diary.filterStartDate,
      filterEndDate: store.diary.filterEndDate,
      isCustom: store.diary.isCustom,
      selectOptions: store.diary.selectOptions,
    };
  },
  (dispatch) => {
    return {};
  }
)(DateFilter);

const divStyles = StyleSheet.create({
  buttonStyle: {
    width: "80%",
    fontSize: "1.2em",
    background: "green",
    color: "white",
  },
});
